import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="header-fixed">
      <div className="container-fluid px-4">
        <div className="d-flex align-items-center justify-content-between">
          {/* LEFT : LOGO */}
          <Link
            to={{
              pathname: "/",
              search: "", // Memaksa query string menjadi kosong
            }}
          >
            <img src="/images/logo.png" height="36" alt="Tes Bakat Indonesia" />
          </Link>

          {/* DESKTOP MENU */}
          <nav className="d-none d-md-flex gap-4 align-items-center">
            <Link
              to={{
                pathname: "/",
                search: "", // Memaksa query string menjadi kosong
              }}
              className="nav-link-custom"
            >
              Home
            </Link>

            <Link to="/login" className="nav-link-custom">
              My Booking
            </Link>
          </nav>

          {/* MOBILE ICON */}
          <div className="d-flex d-md-none align-items-center gap-3">
            <button
              className="btn p-0 fs-3"
              data-bs-toggle="collapse"
              data-bs-target="#mobileMenu"
            >
              <i className="bi bi-list"></i>
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div className="collapse d-md-none mobile-menu-full" id="mobileMenu">
        <div className="mobile-menu-header d-flex align-items-center justify-content-between px-4">
          <span className="fw-semibold text-brand">Main Menu</span>
          <button
            className="btn p-0 fs-3"
            data-bs-toggle="collapse"
            data-bs-target="#mobileMenu"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="mobile-menu-body">
          <Link to="/" className="mobile-menu-item">
            Home
          </Link>
          <a href="#about" className="mobile-menu-item">
            About
          </a>
          <Link to="/login" className="mobile-menu-item">
            My Booking
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
